/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const BillingTypeEnum = {
    Counselling: 'COUNSELLING',
    HpTherapy: 'HP_THERAPY',
    HpTherapyOnSite: 'HP_THERAPY_ON_SITE',
    CostReimbursement: 'COST_REIMBURSEMENT',
    PrivateInsurance: 'PRIVATE_INSURANCE',
    PsychotherapyOnline: 'PSYCHOTHERAPY_ONLINE',
    PsychotherapyOnSite: 'PSYCHOTHERAPY_ON_SITE',
    SelfPayer: 'SELF_PAYER'
} as const;
export type BillingTypeEnum = typeof BillingTypeEnum[keyof typeof BillingTypeEnum];

